import { isQuickShipActivated, quickShipFilterAppInstance } from "./quick-ship-filter-app";
import { isPickupStoreActivated, pickupStoreFilterAppInstance } from "./pickup-store-filter-app";

function availabilityFilters() {
  /**
   * Get text for no-results message
   */
  function getNoResultsText() {
    const $existingMessage = document.querySelector(".no-filter-results div");
    if ($existingMessage && $existingMessage.textContent) {
      return $existingMessage.textContent.trim();
    }

    return "Sorry, there are no results to match your filters.";
  }

  /**
   * Build clear-all href using existing link or current URL
   */
  function getClearAllHref() {
    const existingClearLink = document.querySelector(".no-filter-results a");
    if (existingClearLink && existingClearLink.href) {
      return existingClearLink.href;
    }

    const url = new URL(window.location.href);
    const sortBy = url.searchParams.get("sort_by");
    return `${url.pathname}${sortBy ? `?sort_by=${encodeURIComponent(sortBy)}` : ""}#collection`;
  }

  /**
   * Clear all availability filters without reload; keeps store in localStorage.
   */
  function handleClearAllClick(e) {
    const $link = e.target.closest(".no-filter-results a");
    if (!$link) return;
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("clearAllAvailabilityFilters"));
    window.dispatchEvent(new CustomEvent("quickShipActivated"));
    window.dispatchEvent(new CustomEvent("pickupStoreActivated"));
    showAllProducts();
  }

  /**
   * Toggle the no-results message visibility
   * @param {boolean} hasVisibleProducts
   */
  function toggleNoResultsMessage(hasVisibleProducts) {
    const $productsContainer = document.getElementById("productsGrid");
    if (!$productsContainer) {
      return;
    }

    const $existingFallbacks = document.querySelectorAll(".no-filter-results");

    // If there are visible products, hide any existing no-results messages
    if (hasVisibleProducts) {
      $existingFallbacks.forEach(($el) => {
        $el.style.display = "none";
      });
      return;
    }

    // No visible products - show the no-results message
    if (!$existingFallbacks.length) {
      const $fallback = document.createElement("div");
      $fallback.className = "no-filter-results";
      $fallback.style.width = "100%";
      const $messageContainer = document.createElement("div");
      $messageContainer.textContent = getNoResultsText();
      $fallback.appendChild($messageContainer);

      const clearAllLink = document.createElement("a");
      clearAllLink.setAttribute("role", "button");
      clearAllLink.className = "btn btn-link";
      clearAllLink.href = getClearAllHref();
      clearAllLink.textContent = "Clear all";
      $fallback.appendChild(clearAllLink);

      $productsContainer.appendChild($fallback);
    } else {
      // Show existing fallback(s)
      $existingFallbacks.forEach(($el) => {
        $el.style.display = "";
      });
    }
  }

  /**
   * Show all products
   */
  function showAllProducts() {
    const $productsGrid = document.getElementById("productsGrid");
    if (!$productsGrid) {
      return;
    }

    const $productWrappers = $productsGrid.querySelectorAll(".product-item__wrapper, [id^=\"collection-productItemApp\"]");
    $productWrappers.forEach(($productWrapper) => {
      __.removeClass($productWrapper, "hide");
    });

    toggleNoResultsMessage($productWrappers.length > 0);
  }

  /**
   * Get Shopify store ID from Stockist store data custom_fields
   */
  function getShopifyStoreIdFromStore(store) {
    if (store.custom_fields && Array.isArray(store.custom_fields)) {
      const shopifyIdField = store.custom_fields.find(
        (field) => field.name === "shopify_store_id"
      );
      if (shopifyIdField && shopifyIdField.value) {
        return shopifyIdField.value;
      }
    }
    return null;
  }

  function init() {
    // Delegate "Clear all" click (works for dynamic and Liquid-rendered links)
    document.addEventListener("click", handleClearAllClick);

    // Listen for products loaded (after AJAX filtering)
    window.addEventListener("productsLoaded", () => {
      if (isPickupStoreActivated()) {
        pickupStoreFilterAppInstance.filterByMetafield();
      } else if (isQuickShipActivated()){
        quickShipFilterAppInstance.filterProductsByQuickShip(true);
      } else {
        showAllProducts();
      }
    });
  }

  init();

  return {
    getShopifyStoreIdFromStore,
    showAllProducts,
    toggleNoResultsMessage
  };
}

const availabilityFiltersInstance = availabilityFilters();

export default availabilityFiltersInstance;
